import { render, staticRenderFns } from "./wchatbot.vue?vue&type=template&id=ed03d744"
import script from "./wchatbot.vue?vue&type=script&lang=js"
export * from "./wchatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports